import * as ng from 'angular';
import * as _ from 'underscore';

import {Report} from '.';

export class ReportSelectController {
   static $inject = ['session', 'titleService'];
   constructor(session, titleService) {
      titleService.setTitle('Select a Report');

      this.reports = _.chain(this.reports)
         .filter(r => !r.admin)
         .filter(reportFilter)
         .sortBy('title')
         .value();

      function reportFilter(report:Report) {
         let orgSlug = session.getOrg().slug;
         let brandSlug = session.getBrand().slug;
         let userRole = session.getUser().role;

         let visible = true;

         if (report.brandSlugs) {
            visible = false;

            let brandSlugsMatched = report.brandSlugs.filter(_brandSlug => {
               if (_brandSlug.indexOf('*') !== -1) {
                  return brandSlug.indexOf(_brandSlug.replace('*', '')) == 0;
               } else {
                  return brandSlug === _brandSlug;
               }
            });

            visible = (brandSlugsMatched.length > 0);
         }

         if (report.orgSlug && visible) {
            if (report.orgSlug.indexOf('*') !== -1) {
               visible = orgSlug.indexOf(report.orgSlug.replace('*', '')) == 0;
            } else {
               visible = orgSlug === report.orgSlug;
            }
         }

         if (report.roles && visible) {
            visible = _.contains(report.roles.split(','), userRole);
         }

         return visible;
      }
   }

   reports = Report.reports;
}

ng.module('e360').component('reportSelect', {
   templateUrl: require('./report-select.html'),
   controller: ReportSelectController,
   controllerAs: 'ctrl'
});
